(function() {
    'use strict';

    angular.module('user')
        .controller('ClientDetailsController', ClientDetailsController);

    ClientDetailsController.$inject = ['$state', 'notificationSrvc', 'clientMessagesConst', 'clientDataSrvc', 'clientSrvc', 'clientPermissionsConst', 'checkModelPermissionsSrvc', 'datatableDefaultPageSizeValueConst', 'orderPermissionsConst', 'invoicePermissionsConst', 'clientcontactPermissionsConst', 'searchFilterSrvc', 'momentSrvc', 'orderDataSrvc', 'checkSearchSrvc', 'invoiceDataSrvc', 'contactDataService'];

    function ClientDetailsController($state, notificationSrvc, clientMessagesConst, clientDataSrvc, clientSrvc, clientPermissionsConst, checkModelPermissionsSrvc, datatableDefaultPageSizeValueConst, orderPermissionsConst, invoicePermissionsConst, clientcontactPermissionsConst, searchFilterSrvc, momentSrvc, orderDataSrvc, checkSearchSrvc, invoiceDataSrvc, contactDataService) {
        var self = this;

        self.client = {};
        self.hasEditPermissions = hasEditPermissions;
        self.hasDeletePermissions = hasDeletePermissions;
        self.activate = clientSrvc.activate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.orderLoading = true;
        self.orderRows = [];
        self.orderCols = [{
            title: 'Nr zamówienia',
            value: 'pk',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'E-mail',
            value: 'client_email',
            type: 'text',
            orderValue: 'client__user__email',
            searchable: true,
            orderable: true
        }, {
            title: 'Klient',
            value: 'client_name',
            type: 'text',
            orderValue: 'client__user__first_name',
            searchable: true,
            orderable: true
        }, {
            title: 'Sklep',
            value: 'company_localization_display',
            type: 'text',
            orderValue: 'company_localization',
            searchable: true,
            orderable: true
        }, {
            title: 'Język',
            value: 'lang_display',
            type: 'text',
            orderValue: 'lang',
            searchable: true,
            orderable: true
        }, {
            title: 'Waluta',
            value: 'currency',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Netto',
            value: 'info.final_net_price',
            type: 'decimal'
        }, {
            title: 'Netto produkty',
            value: 'info.products_net_price',
            type: 'decimal'
        }, {
            title: 'Netto wysyłka',
            value: 'info.delivery_price',
            type: 'decimal',
            orderValue: 'delivery_price',
            searchValue: 'delivery_price',
            searchable: true,
            orderable: true
        }, {
            title: 'Stawka VAT',
            value: 'info.vat_percent',
            type: 'decimal',
            orderValue: 'vat_percent',
            searchValue: 'vat_percent',
            searchable: true,
            orderable: true
        }, {
            title: 'Wartość VAT',
            value: 'info.vat_price',
            type: 'decimal'
        }, {
            title: 'Liczba adresów',
            value: 'adresses_count',
            type: 'number',
            searchable: true,
            orderable: true
        }, {
            title: 'Liczba paczek',
            value: 'info.delivery_packages',
            type: 'number',
            orderValue: 'delivery_packages',
            searchValue: 'delivery_packages',
            searchable: true,
            orderable: true
        }, {
            title: 'Metoda płatności',
            value: 'payment_method_display',
            type: 'text',
            orderValue: 'payment_method',
            searchable: true,
            orderable: true
        }, {
            title: 'Status zamówienia',
            value: 'status_display',
            type: 'text',
            orderValue: 'status',
            searchable: true,
            orderable: true
        }, {
            title: 'Termin',
            value: 'realization_date',
            type: 'date',
            searchable: true,
            orderable: true
        }];
        self.orderModelPermissions = orderPermissionsConst;
        self.orderPageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };
        self.orderPageChange = orderPageChange;
        self.orderSearchQuery = {
            pk: null,
            client_email: null,
            client_name: null,
            company_localization_display: null,
            currency: null,
            lang_display: null,
            vat_percent: null,
            adresses_count: null,
            delivery_packages: null,
            delivery_price: null,
            payment_method_display: null,
            status_display: null,
            realization_date: null,
            ordering: null
        };
        self.orderOnSearchQueryChange = orderOnSearchQueryChange;
        self.orderOnClick = orderOnClick;

        self.invoiceLoading = true;
        self.invoiceRows = [];
        self.invoiceCols = [{
            title: 'Nr faktury',
            value: 'number',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Nr zamówienia',
            value: 'order',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Nazwa firmy',
            value: 'company_name',
            type: 'text',
        }, {
            title: 'Sklep',
            value: 'company_localization_display',
            type: 'text',
            orderValue: 'order__company_localization',
            searchable: true,
            orderable: true
        }, {
            title: 'Język',
            value: 'lang_display',
            type: 'text',
            orderValue: 'order__lang',
            searchable: true,
            orderable: true
        }, {
            title: 'Waluta',
            value: 'currency',
            type: 'text',
            orderValue: 'order__currency',
            searchable: true,
            orderable: true
        }, {
            title: 'Netto',
            value: 'net_price',
            type: 'decimal'
        }, {
            title: 'VAT',
            value: 'vat',
            type: 'decimal'
        }, {
            title: 'Brutto',
            value: 'gross_price',
            type: 'decimal',
        }, {
            title: 'Rodzaj faktury',
            value: 'invoice_type_display',
            type: 'text',
        }, {
            title: 'Data wystawienia',
            value: 'issue_date',
            type: 'date',
            searchable: true,
            orderable: true
        }];
        self.invoiceModelPermissions = invoicePermissionsConst;
        self.invoicePageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };
        self.invoicePageChange = invoicePageChange;
        self.invoiceSearchQuery = {
            pk: null,
            order: null,
            issue_date: null,
            number: null,
            company_localization_display: null,
            lang_display: null,
            currency: null,
            ordering: null
        };
        self.invoiceOnSearchQueryChange = invoiceOnSearchQueryChange;

        self.crmCasesLoading = true;
        self.crmCasesRows = [];
        self.crmCasesCols = [{
            title: 'Nr sprawy',
            value: 'pk',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'E-mail',
            value: 'client_email',
            type: 'text',
            orderValue: 'client__user__email',
            searchable: true,
            orderable: true
        }, {
            title: 'Klient',
            value: 'client_name',
            type: 'text',
            orderValue: 'client__user__first_name',
            searchable: true,
            orderable: true
        }, {
            title: 'Rodzaj sprawy',
            value: 'competency',
            orderValue: 'competency__name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Osoba odpowiedzialna',
            value: 'responsible_person_name',
            type: 'text',
            orderValue: 'responsible_person__user__first_name',
            searchable: true,
            orderable: true
        }, {
            title: 'Status',
            value: 'status_display',
            type: 'text'
        }];
        self.crmCasesModelPermissions = clientcontactPermissionsConst;
        self.crmCasesPageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };
        self.crmCasesPageChange = crmCasesPageChange;
        self.crmCasesSearchQuery = {
            pk: null,
            client_email: null,
            client_name: null,
            competency: null,
            responsible_person_name: null,
            ordering: null
        };
        self.crmCasesOnSearchQueryChange = crmCasesOnSearchQueryChange;
        self.crmCasesOnClick = crmCasesOnClick;

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        activate();

        function activate() {
            getClient();
            getOrders();
            getInvoices();
            getCrmCases();
        }

        function getClient() {
            return clientDataSrvc.getFlattened({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.client = response;
                return response;
            });
        }

        function getOrders(filterObj) {
            self.orderLoading = true;

            if (!filterObj) {
                filterObj = {
                    client_pk: $state.params.pk,

                    page: self.orderPageOpts.page,
                    page_size: self.orderPageOpts.pageSize,

                    pk: self.orderSearchQuery.pk,
                    client_email: self.orderSearchQuery.client_email,
                    client_name: self.orderSearchQuery.client_name,
                    company_localization_display: self.orderSearchQuery.company_localization_display,
                    currency: self.orderSearchQuery.currency,
                    lang_display: self.orderSearchQuery.lang_display,
                    vat_percent: self.orderSearchQuery.vat_percent,
                    adresses_count: self.orderSearchQuery.adresses_count,
                    delivery_packages: self.orderSearchQuery.delivery_packages,
                    delivery_price: self.orderSearchQuery.delivery_price,
                    payment_method_display: self.orderSearchQuery.payment_method_display,
                    status_display: self.orderSearchQuery.status_display,
                    realization_date: searchFilterSrvc.getDateValue(self.orderSearchQuery.realization_date),
                    ordering: self.orderSearchQuery.ordering,
                };
            }
            return orderDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.orderRows = response.results;
                        self.orderPageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getOrders);
                        }
                    }
                ).finally(
                    function(response) {
                        self.orderLoading = false;
                        return response;
                    }
                );
        }

        function getInvoices(filterObj) {
            self.invoiceLoading = true;

            if (!filterObj) {
                filterObj = {
                    client_pk: $state.params.pk,

                    page: self.invoicePageOpts.page,
                    page_size: self.invoicePageOpts.pageSize,

                    pk: self.invoiceSearchQuery.pk,
                    order: self.invoiceSearchQuery.order,
                    issue_date: searchFilterSrvc.getDateValue(self.invoiceSearchQuery.issue_date),
                    number: self.invoiceSearchQuery.number,
                    company_localization_display: self.invoiceSearchQuery.company_localization_display,
                    lang_display: self.invoiceSearchQuery.lang_display,
                    currency: self.invoiceSearchQuery.currency,
                    ordering: self.invoiceSearchQuery.ordering,
                };
            }
            return invoiceDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.invoiceRows = response.results;
                        self.invoicePageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getInvoices);
                        }
                    }
                ).finally(
                    function(response) {
                        self.invoiceLoading = false;
                        return response;
                    }
                );
        }

        function getCrmCases(filterObj) {
            self.crmCasesLoading = true;

            if (!filterObj) {
                filterObj = {
                    client_pk: $state.params.pk,

                    page: self.crmCasesPageOpts.page,
                    page_size: self.crmCasesPageOpts.pageSize,

                    pk: self.crmCasesSearchQuery.pk,
                    client_email: self.crmCasesSearchQuery.client_email,
                    client_name: self.crmCasesSearchQuery.client_name,
                    competency: self.crmCasesSearchQuery.competency,
                    responsible_person_name: self.crmCasesSearchQuery.responsible_person_name,
                    ordering: self.crmCasesSearchQuery.ordering
                };
            }
            return contactDataService.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.crmCasesRows = response.results;
                        self.crmCasesPageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getCrmCases);
                        }
                    }
                ).finally(
                    function(response) {
                        self.crmCasesLoading = false;
                        return response;
                    }
                );
        }

        function hasEditPermissions() {
            return !checkModelPermissionsSrvc.isDenied(
                clientPermissionsConst.update);
        }

        function hasDeletePermissions() {
            return !checkModelPermissionsSrvc.isDenied(
                clientPermissionsConst.delete);
        }

        function onEdit() {
            $state.go('layout.client.update', { pk: self.client.pk });
        }

        function onDelete() {
            clientSrvc.remove(row, function(response) {
                $state.go('layout.client.list');
            });
        }

        function orderPageChange() {
            return getOrders();
        }

        function orderOnSearchQueryChange() {
            return getOrders();
        }

        function orderOnClick(row) {
            $state.go('layout.order.details', {pk: row.pk});
        }

        function invoicePageChange() {
            return getInvoices();
        }

        function invoiceOnSearchQueryChange() {
            return getInvoices();
        }

        function crmCasesPageChange() {
            return getCrmCases();
        }

        function crmCasesOnSearchQueryChange() {
            return getCrmCases();
        }

        function crmCasesOnClick(row) {
            $state.go('layout.messages.update', {pk: row.pk});
        }
    }
})();
